import type { Styles } from "react-modal";
import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const CUSTOM_MODAL_STYLES: Styles = {
    content: { width: 480 },
};

export const StyledTermsBox = styled.div`
    padding: 16px;
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[25]};
    border: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledTermsTitle = styled.div`
    ${mixins.setFontVariant("subtitle2", colorsPalettes.carbon[500])};
    margin-bottom: 4px;
`;

export const StyledTermsText = styled.div`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon[400])};
`;

export const StyledTermsLink = styled.a`
    ${mixins.setFontVariant("caption", colorsPalettes.blue[400])};
    display: inline-flex;
    align-items: flex-start;
    gap: 4px;
    margin-top: 8px;
    text-decoration: none;

    > svg {
        flex-shrink: 0;
        margin-top: 2px;
    }

    &:hover {
        text-decoration: underline;
    }
`;
